import { createAction, props } from "@ngrx/store";
import type { CalendarIntegration } from "./calendar-integration.models";

export const CalendarIntegrationFetchRequest = createAction('[CalendarIntegration] Fetch Request');
export const CalendarIntegrationFetchSuccess = createAction(
  '[CalendarIntegration] Fetch Success',
  props<{ integrations: CalendarIntegration[] }>()
);
export const CalendarIntegrationFetchFailure = createAction(
  '[CalendarIntegration] Fetch Failure',
  props<{ error: string }>()
);

export const CalendarIntegrationUpsertRequest = createAction(
  '[CalendarIntegration] Upsert Request',
  props<{ payload: { provider: string; access_token: string; refresh_token: string; expires_at?: string; scopes?: string[]; account_email?: string; external_user_id?: string; external_calendar_id?: string } }>()
);
export const CalendarIntegrationUpsertSuccess = createAction(
  '[CalendarIntegration] Upsert Success',
  props<{ integration: CalendarIntegration }>()
);
export const CalendarIntegrationUpsertFailure = createAction(
  '[CalendarIntegration] Upsert Failure',
  props<{ error: string }>()
);

export const CalendarIntegrationDisconnectRequest = createAction(
  '[CalendarIntegration] Disconnect Request',
  props<{ provider: string }>()
);
export const CalendarIntegrationDisconnectSuccess = createAction(
  '[CalendarIntegration] Disconnect Success',
  props<{ provider: string }>()
);
export const CalendarIntegrationDisconnectFailure = createAction(
  '[CalendarIntegration] Disconnect Failure',
  props<{ error: string }>()
);

